import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "@vp/shared/authentication";
import { ANON_CONFIG } from "@vp/shared/tokens";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class ServerErrorInterceptor implements HttpInterceptor {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly router = inject(Router);

  readonly isAnonApi = !!inject(ANON_CONFIG);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse): Observable<never> => {
        if (error.status === 401 && !this.authenticationService.isLoggingOut) {
          if (this.isAnonApi) {
            this.router.navigate(["/error"]);
          } else {
            this.router.navigate(["/login"]);
          }
        }
        return throwError(error);
      })
    );
  }
}
